export const nurgalieva = {
    id: "nurgalieva",
    name: { ru: "Нургалиева Зере Тилеубековна", kz: "Нұрғалиева Зере Тілеубекқызы" },
    position: { ru: "Врач УЗИ", kz: "Ультрадыбыстық зерттеу дәрігері" },
    department: "diagnostics",
    image: "/team_photoes/new/Зере Тілеубекқызы.svg",
    experience: {
      ru: "7 лет",
      kz: "7 жыл"
    },
    education: {
      ru: `2010–2015 — Государственный медицинский университет г. Семей, бакалавр медицины
2015–2017 — Государственный медицинский университет г. Семей, интернатура по специальности «Терапия»
2017–2019 — Государственный медицинский университет г. Семей, резидентура по специальности «Лучевая диагностика»`,
      kz: `2010–2015 — Семей қаласының Мемлекеттік медицина университеті, медицина бакалавры
2015–2017 — Семей қаласының Мемлекеттік медицина университеті, «Терапия» мамандығы бойынша интернатура
2017–2019 — Семей қаласының Мемлекеттік медицина университеті, «Сәулелік диагностика» мамандығы бойынша резидентура`
    },
    specialization: {
      ru: `Лучевая диагностика
Ультразвуковая диагностика
Рентгенологическая диагностика
Компьютерная томография
Магнитно-резонансная томография`,
      kz: `Сәулелік диагностика
Ультрадыбыстық диагностика
Рентгенологиялық диагностика
Компьютерлік томография
Магнитті-резонанстық томография`
    },
        work: {
    ru: `• 2019–2022 — Врач рентгенолог по совместительству, Больница скорой медицинской помощи, г. Семей
• 2019–2022 — Врач УЗИ, Поликлиника 4, г. Семей
• 2020 — Врач рентгенолог, провизорный стационар Карагайлы
• 2020–2021 — Врач рентгенолог по совместительству, УГ НАО МУС
• 2021–по настоящее время — Врач рентгенолог (дистанционно), Инфекционная больница, г. Семей
• 2022–по настоящее время — Врач УЗИ, Спортивный медицинский центр`,
    kz: `• 2019–2022 — Рентгенолог дәрігері (қосымша), Жедел медициналық көмек ауруханасы, Семей қ.
• 2019–2022 — УЗИ дәрігері, 4-ші емхана, Семей қ.
• 2020 — Рентгенолог дәрігері, Қарағайлы провизорлық стационары
• 2020–2021 — Рентгенолог дәрігері (қосымша), МУС АҚ УГ
• 2021–қазіргі уақытқа дейін — Рентгенолог дәрігері (қашықтан), Жұқпалы аурухана, Семей қ.
• 2022–қазіргі уақытқа дейін — УЗИ дәрігері, Спорттық медициналық орталық`,
  },
certificates: {
    ru: `Квалификация:
• Вторая категория по специальности «Лучевая диагностика»`,
    kz: `Біліктілігі:
• «Сәулелік диагностика» мамандығы бойынша екінші санат`,
  }
  };
